import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import { Box, Grid, Paper, Stack } from '@mui/material';
import GlobalMultiSelect from '../../../../components/mui/GlobalMultiSelect';
import { useDispatch, useSelector } from 'react-redux';
import GlobalDatagrid from '../../../../components/mui/DataGrid/GlobalDatagrid';
import { employeeTableHeader } from '../../../../components/datagrid/hrDashboard/employeeTableHeader';
import { getAllDepartmenst } from '../../../../redux/features/postWorkingHoursSlice';
import {
  clearWingsAndReportingHeads,
  getAllLeaveTypes,
  getEmployeeStatuses,
  getEmployeeTypes,
  getWingsAndReportingHeadsUnderDepartments,
  totalEmployees,
} from '../../../../redux/features/hrDashboard';
import { savePaginationData } from '../../../../redux/features/globalDatagridSlice';
import { useLocation } from 'react-router-dom';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import FoodFine from './FoodFine';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { foodAvailability } from '../../../../utils/constants/GlobalStaticData';

const gender = [
  { id: 1, value: 'Male' },
  { id: 2, value: 'Female' },
];

const presentStatuses = [
  { id: 1, value: 'Present Marked' },
  { id: 2, value: 'Present Not Marked' },
];
const NewUser = () => {
  const { role } = useSelector((state) => state);
  const [foodFineEmployeeId, setFoodFineEmployeeId] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [apiTrigger, setApiTrigger] = useState(false);
    const [selectedFoodStatus, setSelectedFoodStatus] = useState({});


  const editPermission = role.otherConfig.some((permi) => permi.title == 'user edit');
  const foodFinePermission = role.otherConfig.some((permi) => permi.title == 'food-fine-action');
  const location = useLocation();
  const genderFilter = location.state?.genderFilter;
  const employeTypeFilter = location.state?.employeTypeFilter;
  const employeeStatusFilter = location.state?.employeeStatusFilter;
  const leaveFilter = location.state?.leaveFilter;
  const attendenceFilter = location.state?.attendenceFilter;
  const departmentFilter = location.state?.departmentFilter;
  const excludeDeptNames = location.state?.excludeDeptNames;

  const dispatch = useDispatch();
  const [departmentNames, setDepartmentNames] = useState(departmentFilter ? departmentFilter : []);
  const [genderNames, setGenderNames] = useState(genderFilter ? genderFilter : []);
  const [employeTypeName, setEmployeTypeName] = useState(employeTypeFilter ? employeTypeFilter : []);
  const [employeStatus, setEmployeStatus] = useState(employeeStatusFilter ? employeeStatusFilter : []);
  const [wingNames, setWingNames] = useState([]);
  const [reportingHeadNames, setReportingHeadNames] = useState([]);
  const [leaveName, setLeaveName] = useState(leaveFilter ? leaveFilter : []);
  const [presentNames, setPresentNames] = useState(attendenceFilter ? attendenceFilter : []);

  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search } = paginationData;
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const { departments } = useSelector((store) => store.postWorking);
  const { resData, loading, employeeStatuses, employeeTypes, wings, reportingHeads, leaveTypes } = useSelector(
    (store) => store.hrDashboard,
  );
  const { data, meta } = resData;
  const dispatchParams = {
    paginationData,
    departmentNames,
    genderNames,
    employeTypeName,
    employeStatus,
    reportingHeadNames,
    wingNames,
    leaveName,
    presentNames,
    fromDate,
    toDate,
    selectedFoodStatus:selectedFoodStatus?.id===-1?null:selectedFoodStatus?.id,
  };

  useEffect(() => {
    //WHEN DEPARTMENT SELECT IT WILL CALL CORRESPONDING WINGS AND REPORTING HEADS UNDER THAT DEPARTMENT

    //FOR GETTING DEPARTMENT IDS TO FETCH
    if (departmentNames.length > 0) {
      //ADDITINALY ADDED TO AVOID EVERYTIME CALL PREDATA API
      let departmentIds = departments
        .filter((dept) => departmentNames.some((depname) => dept.departmentName === depname))
        .map((dept) => dept.departmentId);
      dispatch(getWingsAndReportingHeadsUnderDepartments(departmentIds)).then((res) => {
        if (res.payload.status === 'success' && wingNames.length > 0) {
          const selectedModifiedWings = wingNames.filter((selectedWingName) =>
            res.payload.data.wings.some((wing) => wing.wing_name === selectedWingName),
          );
          setWingNames(selectedModifiedWings);
        }
      });
    } else {
      //IF NO DEPT SELECTED THEN CLEAR WINGS AND REPORTING HEADS OF REDUX STATE TO AVOID PREVIOUS DATA DISPLAY IN MODAL
      dispatch(clearWingsAndReportingHeads());
    }
  }, [departmentNames]);

  useEffect(() => {
    if (leaveName.length == 0 && presentNames.length == 0) {
      setFromDate('');
      setToDate('');
    }
  }, [leaveName, presentNames]);
  useEffect(() => {
    if (departments.length == 0 || employeeStatuses.length == 0) {
      dispatch(getAllDepartmenst());
      dispatch(getEmployeeStatuses());
      dispatch(getEmployeeTypes());
      dispatch(getAllLeaveTypes());
    }
  }, []);

  // useEffect(() => {
  //   //WHEN OPEN IS FALSE AND SEARCH IS TRUE THEN IT WILL RESET THE SEARCH,OTHER WISE PREVIOS MODAL SEARCH IS REMAINING AND IT WILL NOT FETCH THE DATA WITH THAT SEARCH
  //   if (!open && search) {
  //     dispatch(savePaginationData({ search: "" }));
  //   }
  // }, [open]);

  useEffect(() => {
    dispatch(savePaginationData({ ...paginationData, pageNum: 1 }));
  }, [search]);

  useEffect(() => {
    if (paginationData?.pageNum) {
      // SAME COMPONENT IS USING IN WORKSPACE AS ALL-USERS SO THERE IS NO MODAL OPEN SO CREATED AN EXTRA PROP CALLED WORKSPACE TO IDENTIFY WHICH MAKES WORKSPACE VIEW TRUE
      dispatch(totalEmployees(dispatchParams));
    }
  }, [
    gridSize,
    pageNum,
    search,
    departmentNames,
    genderNames,
    employeTypeName,
    employeStatus,
    reportingHeadNames,
    wingNames,
    leaveName,
    presentNames,
    toDate,
    fromDate,
    apiTrigger,
    selectedFoodStatus
  ]);

  useEffect(() => {
    if (
      Array.isArray(excludeDeptNames) &&
      excludeDeptNames.length > 0 &&
      Array.isArray(departments) &&
      departments.length > 0
    ) {
      const filteredNames = departments
        .filter((dep) => dep?.departmentName && !excludeDeptNames.includes(dep?.departmentName))
        .map((dep) => dep.departmentName);
      setDepartmentNames(filteredNames);
    }
  }, [excludeDeptNames, departments]);

  return (
    <GlobalWrapper title={'User'}>
      <>
        <Box sx={{ mb: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <Box>
                <GlobalMultiSelect
                  disabled={departmentFilter ? true : false || loading}
                  label={'Department Filter'}
                  fullWidth
                  arrayState={departmentNames}
                  arraySetState={setDepartmentNames}
                  data={departments}
                  keys={{ id: 'departmentId', value: 'departmentName' }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={2}>
              <Box>
                <GlobalMultiSelect
                  disabled={genderFilter ? true : false || loading}
                  fullWidth
                  label={'Gender Filter'}
                  arrayState={genderNames}
                  arraySetState={setGenderNames}
                  data={gender}
                  keys={{ id: 'id', value: 'value' }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <Box>
                <GlobalMultiSelect
                  disabled={employeTypeFilter ? true : false || loading}
                  label={'Employee Type'}
                  fullWidth
                  arrayState={employeTypeName}
                  arraySetState={setEmployeTypeName}
                  data={employeeTypes}
                  keys={{ id: 'id', value: 'value' }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
              <Box>
                <GlobalMultiSelect
                  disabled={employeeStatusFilter ? true : false || loading}
                  label={'Employee Satus'}
                  arrayState={employeStatus}
                  arraySetState={setEmployeStatus}
                  fullWidth
                  data={employeeStatuses}
                  keys={{ id: 'id', value: 'value' }}
                />
              </Box>
            </Grid>

            <>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Box>
                  <GlobalMultiSelect
                    disabled={loading}
                    label={'Wing Filter'}
                    fullWidth
                    arrayState={wingNames}
                    arraySetState={setWingNames}
                    data={wings?.flat()}
                    keys={{ id: 'wing_id', value: 'wing_name' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Box>
                  <GlobalMultiSelect
                    disabled={loading}
                    label={'Reporting Head'}
                    fullWidth
                    arrayState={reportingHeadNames}
                    arraySetState={setReportingHeadNames}
                    data={reportingHeads}
                    keys={{ id: 'reporting_head', value: 'name' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Box>
                  <GlobalMultiSelect
                    disabled={presentNames.length > 0 || loading || leaveFilter ? true : false}
                    label={'Leave Types'}
                    fullWidth
                    arrayState={leaveName}
                    arraySetState={setLeaveName}
                    data={leaveTypes}
                    keys={{ id: 'leaveTypeId', value: 'leaveFullName' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <Box>
                  <GlobalMultiSelect
                    disabled={leaveName.length > 0 || loading || attendenceFilter ? true : false}
                    label={'Present Status'}
                    fullWidth
                    arrayState={presentNames}
                    arraySetState={setPresentNames}
                    data={presentStatuses}
                    keys={{ id: 'id', value: 'value' }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box>
                  <FromAndToDatePicker
                    disabled={leaveName.length == 0 && presentNames.length == 0}
                    fromDate={fromDate}
                    toDate={toDate}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                  />
                </Box>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Box>
                  <GlobalSelectFieldWithoutFormikNew
                    keys={{ itemId: 'id', itemValue: 'name' }}
                    data={foodAvailability}
                    label={'Food Availability'}
                    fullWidth={true}
                    selectedDetails={selectedFoodStatus}
                    setChange={setSelectedFoodStatus}
                    sx={{ maxWidth: 200, width: 200 }}
                  />
                </Box>
              </Grid>
            </>
          </Grid>
        </Box>

        <Box>
          <Paper>
            <GlobalDatagrid
              tableHead={employeeTableHeader(editPermission, foodFinePermission, setFoodFineEmployeeId, setRowData)}
              rows={data || []}
              meta={meta?.totalRecords}
              rowUniqueId="sl_no"
              loading={loading}
            />
          </Paper>
        </Box>
        <Box>
          <GlobalDialog
            title={'Food Fine'}
            open={Boolean(foodFineEmployeeId)}
            setOpen={(val) => {
              if (!val) setFoodFineEmployeeId(null);
            }}
            closeButton={true}
            content={
              <FoodFine
                setApiTrigger={setApiTrigger}
                setRowData={setRowData}
                setFoodFineEmployeeId={setFoodFineEmployeeId}
                employeeId={foodFineEmployeeId}
                rowData={rowData}
              />
            }
            maxWidth={'sm'}
            fullWidth={true}
          />
        </Box>
      </>
    </GlobalWrapper>
  );
};

export default NewUser;
